var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-row',{style:({
      cursor: _vm.condition ? 'not-allowed' : 'unset',
    })},[_c('b-col',{style:({
        pointerEvents: _vm.condition ? 'none' : 'unset',
      })},[_c('b-overlay',{attrs:{"variant":"light","opacity":"0.3","show":_vm.condition,"rounded":"sm"},scopedSlots:_vm._u([{key:"overlay",fn:function(){return [_c('div',{staticClass:"text-center"},[_c('font-awesome-icon',{staticClass:"text-secondary opacity-1",attrs:{"icon":"lock","size":"4x"}})],1)]},proxy:true}])},[_vm._t("lock-overlay-content")],2)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }